import React from 'react';
import { Modal } from '../ui';
import { Cloud } from 'lucide-react';
import { useUserStore } from '../../store/userStore';
import { usePenpal } from '../../hooks/usePenpal';
import upsellImage from '../../assets/images/upsell2.png';

interface UpsellModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UpsellModal: React.FC<UpsellModalProps> = ({ isOpen, onClose }) => {
  const { account } = useUserStore();
  const { openExternalUrl } = usePenpal();

  const handleUpgrade = () => {
    const url = 'https://folge.me/go/cloud?cloudemail=' + encodeURIComponent(account?.email || '') + '#pricing';
    openExternalUrl(url);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      noHeader
    >
      <div className="text-black text-sm">
        <div 
          className="h-[150px]"
          style={{ 
            backgroundImage: `url(${upsellImage})`, 
            backgroundSize: '100%', 
            backgroundPosition: '55% 99%' 
          }}
        >
          &nbsp;
        </div>
        <div className="p-4 flex flex-col gap-y-6 justify-center items-center">
          <div className="text-2xl font-semibold text-center flex justify-center items-center">
            <Cloud size={26} className="mr-2 fill-blue-500 text-blue-500" />
            <div>Unlock Folge Cloud</div>
          </div>
          <p>
            Make the most of Folge Cloud and Online Guides - upgrade to Folge Cloud Pro! 
          </p>
          <p>Publish up to 1,000 guides, add custom branding, upload your logo, and unlock even more features.</p>
          <button
            className="inline-block mx-5 my-1 rounded bg-indigo-600 disabled:opacity-50 px-4 py-3 w-[150px] text-md font-medium text-white transition hover:shadow-xl focus:outline-none focus:ring active:bg-indigo-500"
            onClick={handleUpgrade}
          >
            Upgrade
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UpsellModal; 